module.exports = __webpack_public_path__ + "img/prize-bg.dd0fa714.png";